'use strict';
/**
 * @ngdoc service
 * @name webAgro1App.SafrasService
 * @description
 * # SafrasService
 * Factory in the webAgro1App.
 */
angular.module('webAgro1App').factory('SafrasService', function($http) {
  return {
    list: function(params) {
      return $http.get(`${SERVER }v2/safras`, { params: params });
    },

    listAll: function(filters = { all: true }) {
      return this.list(filters);
    },

    get: function(id) {
      return $http.get(`${SERVER}v1/safras/${ id}`);
    },

    inactivate: function(id) {
      return $http.delete(`${SERVER}v1/safras/${ id}`);
    },

    activate: function(id) {
      return $http.patch(`${SERVER}v1/safras/${ id}`, { safra: { st_encerrada: 'N' } });
    },

    save: function(safra) {
      return $http({
        method: safra.id ? 'PATCH' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER}${API_VERSION}safras/${ safra.id || ''}`,
        data: { safra: safra }
      });
    }
  };
});
